<div
  class="formio-loader-wrapper"
  *ngIf="isLoading">
  <div class="formio-loader"></div>
</div>
